export const CUSTOM_SITES_PAGE_TITLE_FF = 'confluence.frontend.custom-sites.page-header-and-title';
export const EMOJI_SIZE_MEDIUM = 40;
export const EMOJI_SIZE_LARGE = 80;
